






















import { Watch, Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class FacetInputRadio extends Vue {
    @Prop({ required: true }) options!: [{ label: string, value: string|number }]
    @Prop() value!: string|number
    internalValue: string|number = null

    mounted(): void {
        this.onValueChanged()
    }

    @Watch('value')
    onValueChanged(): void {
        this.internalValue = this.value
    }

    @Watch('internalValue')
    selectOption(v: string|number): void {
        if (v === this.value) {
            return
        }

        this.$emit('input', this.internalValue)
    }
}
